import { Injectable } from '@angular/core';
import {
  BrandRegistryEntry,
  BRANDS_REGISTRY,
  DEFAULT_BRAND,
} from './brands.registry';

/**
 * Servicio que resuelve un brandCode (string) a su entry en el registry.
 *
 * Si el brandCode está en el registry → devuelve ese entry.
 * Si no → devuelve DEFAULT_BRAND (fallback sin crash).
 *
 * La comparación es case-insensitive y se normaliza a lowercase para
 * evitar issues si el backend cambia el casing.
 */
@Injectable({ providedIn: 'root' })
export class BrandAssetsService {
  resolve(brandCode: string | null | undefined): BrandRegistryEntry {
    if (!brandCode) {
      return DEFAULT_BRAND;
    }
    const normalized = brandCode.trim().toLowerCase();
    const match = BRANDS_REGISTRY.find(
      entry => entry.brandCode.toLowerCase() === normalized
    );
    return match ?? DEFAULT_BRAND;
  }

  isRegistered(brandCode: string | null | undefined): boolean {
    if (!brandCode) {
      return false;
    }
    const normalized = brandCode.trim().toLowerCase();
    return BRANDS_REGISTRY.some(
      entry => entry.brandCode.toLowerCase() === normalized
    );
  }
}
